<template>
  <v-app>
    <v-container>
      <v-row justify="center" align="center">
        <v-col v-if="timeoutmsg === '1'" cols="12" sm="8" md="8">
          <div data-v-26c8891c="" class="dl-alert-login dl-info-login">
            <div data-v-26c8891c="" class="dl-mr-12">
              <i slot="right" data-v-26c8891c="" role="img" class="dl-icon icon-info"
                ><svg slot="right" viewBox="0 0 24 24" class="dl-icon-svg" style="height: 24px">
                  <path
                    slot="right"
                    d="M12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22ZM11 7H13V9H11V7ZM11 11H13V17H11V11Z"
                  ></path></svg
              ></i>
            </div>
            <div data-v-26c8891c="" class="content">Your session has expired due to inactivity. Please log in again to continue work.</div>
          </div>
        </v-col>
        <v-col cols="12" sm="8" md="6">
          <div class="d-flex justify-center">
            <img src="delavalplus.svg" alt="" class="image" />
          </div>
          <Login :redirect="redirect"> </Login>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import Login from "./components/Login";
export default {
  name: "App",
  components: {
    Login,
  },
  props: { redirect: { type: Function, default: function() {} } },
  data() {
    return {
      timeoutmsg: new URL(window.location.href).searchParams.get("timeoutmsg"),
    };
  },
};
</script>

<style>
.image {
  width: 200px;
}

.v-main {
  background-color: #fafbfc;
}
.dl-alert-login.dl-info-login {
  background-color: #d9f2ff;
  border-left: 3px solid #0091ff;
}
.dl-alert-login-login .dl-mr-12 {
  margin: 4px 12px 0 0;
}
.dl-alert-login .icon-info-login {
  color: #0091ff;
}
.dl-alert-login .content {
  flex-grow: 1;
  padding: 1px 12px 4px 14px;
}
.dl-alert-login .dl-icon-svg {
  fill: #0091ff;
}
.dl-alert-login {
  color: #333;
  display: flex;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 12px;
  padding: 16px 16px 12px;
  position: relative;
}
div.container {
  padding: 40px 0;
}
</style>
